import React from 'react';

interface LoadingAnimationProps {
  message?: string;
  className?: string;
}

const LoadingAnimation: React.FC<LoadingAnimationProps> = ({
  message = "Loading...",
  className = ""
}) => {
  return (
    <div className={`flex flex-col items-center justify-center min-h-screen bg-white ${className}`}>

      <div className="relative">
        {/* Minimalist Rotating Ring */}
        <div className="w-24 h-24 border-2 border-gray-100 rounded-full"></div>
        <div className="absolute top-0 left-0 w-24 h-24 border-2 border-transparent border-t-black rounded-full animate-spin"></div>

        {/* Centered Logo */}
        <div className="absolute inset-0 flex items-center justify-center">
          <img
            src="/iconredi.png"
            alt="RedirectQR Logo"
            className="w-10 h-10 object-contain grayscale opacity-80 animate-pulse"
          />
        </div>
      </div>

      {/* Elegant Loading Text */}
      <div className="mt-8 text-center">
        <p className="text-gray-400 text-sm uppercase tracking-widest font-medium animate-pulse">
          {message}
        </p>
      </div>
    </div>
  );
};

export default LoadingAnimation;
